import React, { useState } from 'react';
import { Button, TextField,Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Rodape from './rodape.js';
import {extractUTMTags} from './utm_tags.js';
import { Header } from './header.js';

const utmTags = extractUTMTags();

function VerifyAccount() {

  const Navigate = useNavigate();

  const handleVerification = () => {
    Navigate(`/logon`);
  };

  const [isMobile, setIsMobile] = React.useState(false);
  // Function to check if the device is a mobile
  const checkIfMobile = () => {
      const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
      setIsMobile(isMobileDevice);
  };
  React.useEffect(() => {
      checkIfMobile();
      // Add event listener to check if the device type changes
      window.addEventListener('resize', checkIfMobile);
      // Remove event listener on component unmount
      return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return (
    <>
    <Header isMobile={isMobile}/>
    <section id="form" className="section">
    <h1>Verificação de conta</h1>
    <div className="form-container">
      <h2>Agora falta verificar seu email</h2>
      <p>Para isso, abra a sua caixa de entrada, procure pelo email enviado para verificação de conta e clique no link enviado.</p>
      <p><b>Depois de fazer isso,</b> clique no botão abaixo para fazer seu primeiro login no site Domínio Elétrico.</p>
      <Button type='submit' variant='contained' onClick={handleVerification}>Já verifiquei</Button>
    </div>
    </section>
    <Rodape />
    </>
  );
}

export default VerifyAccount;
